import { jsx as _jsx } from "react/jsx-runtime";
import { Paper } from "@mui/material";
import React from "react";
export const CardItem = React.forwardRef(({ children, padding = 1, selected, disabled, hoverable, onClick, sx, ...props }, forwardedRef) => {
    return (_jsx(Paper, { ref: forwardedRef, onClick: !disabled ? onClick : undefined, sx: theme => ({
            display: "block",
            color: "inherit",
            textDecoration: "none",
            cursor: onClick && !disabled ? "pointer" : undefined,
            boxShadow: selected ? "inset 0 0 0 2px #377dc3" : undefined,
            opacity: disabled ? theme.palette.action.disabledOpacity : undefined,
            padding,
            ...(hoverable
                ? { ["&:hover"]: { backgroundColor: theme.palette.grey[100] } }
                : undefined),
            ...sx?.(theme),
        }), ...props, children: children }));
});
//# sourceMappingURL=CardItem.js.map